import { tv } from "@/utils/tv.config";

export const menuItemClasses = tv({
  base: [
    "Menu__item",
    "cursor-pointer",
    "flex",
    "px-4",
    "py-3",
    "text-sm",
    "leading-4",
    "tracking-wide",
    "outline-none",
    "select-none",
    "data-[highlighted]:before:absolute",
    "data-[highlighted]:before:inset-x-1",
    "data-[highlighted]:before:inset-y-0",
    "data-[highlighted]:before:z-[-1]",
    "data-[highlighted]:before:rounded-md",
    "data-[highlighted]:before:bg-primary-light/20",
    "data-[highlighted]:text-black",
    "data-[highlighted]:font-display",
    "data-[highlighted]:relative",
    "data-[highlighted]:z-0",
  ],
  variants: {},
});
